import { render, staticRenderFns } from "./WechslerForm.vue?vue&type=template&id=5c531572"
import script from "./WechslerForm.vue?vue&type=script&lang=js"
export * from "./WechslerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports